export const PASSWORD_MIN_LENGTH = 8;

interface IUserToken {
  token: string;
  expireAt: number;
}
/**
 * Return user stored token
 *
 * @return {*}  {IUserToken}
 */
export const getUserToken = (): IUserToken => {
  const userToken: IUserToken = JSON.parse(
    localStorage.getItem('user') || '{}'
  );

  return userToken;
};

export interface IPasswordMatch {
  isValid: boolean;
  minLength: boolean;
  hasNumber: boolean;
  hasUpperCase: boolean;
  hasLowerCase: boolean;
  hasSpecialCharacter: boolean;
}
/**
 * Check if password match rules
 * At least 8 characters long
 * At least one lowercase character
 * At least one uppercase character
 * At least one number
 *
 * @param {string} password
 * @return {*}  {IPasswordMatch}
 */
export const passwordMatch = (password: string): IPasswordMatch => {
  const minLength = password.length >= PASSWORD_MIN_LENGTH;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialCharacter = /[^a-zA-Z0-9\s]/g.test(password);

  return {
    isValid: hasUpperCase && hasLowerCase && hasNumber && minLength,
    hasUpperCase,
    hasLowerCase,
    hasNumber,
    minLength,
    hasSpecialCharacter,
  };
};
